// Assistant translations for all languages
// This file will be merged into the main i18n.ts

export const assistantTranslations: Record<string, any> = {
  en: {
    title: "AI Assistant",
    subtitle: "Your private financial AI assistant",
    state_green_headline: "Keep chillin'",
    state_yellow_headline: "Watch out",
    state_red_headline: "D'oh!",
    state_green_support_1: "Everything balanced and running smoothly.",
    state_green_support_2: "Cash flow stable · No immediate risks detected.",
    state_green_support_3: "All key indicators are within healthy ranges.",
    state_green_support_4: "No significant changes since your last check-in.",
    state_green_support_5: "Your financial activity looks steady and predictable.",
    state_green_support_6: "Everything is operating within expected parameters.",
    state_yellow_support: "Expenses are trending up compared to the previous period.",
    state_red_support: "Your cash flow is negative.",
    today_in_finances: "Today in your finances",
    green_insight_1: "Expenses remained stable this week",
    green_insight_2: "2 invoices expected in the next 7 days",
    green_insight_3: "No unusual spending patterns detected",
    yellow_insight_1: "Expenses increased vs last month",
    yellow_insight_2: "Cash outflows are accelerating",
    yellow_insight_3: "One category driving most of the growth",
    red_insight_1: "What's causing this",
    red_insight_2: "Expenses you can act on",
    red_insight_3: "When your balance might recover",
    green_message: "Everything looks stable right now. I can help you review your cash flow, explore expenses, or plan ahead.",
    yellow_message: "I've noticed your expenses are increasing. I can break them down by category or show how this affects your cash flow.",
    red_message: "Your cash flow is currently negative. I can help you understand what's causing it, identify expenses to act on, or see when your balance might recover.",
    no_bank_title: "Start the conversation",
    no_bank_description: "Once your bank is connected, your money can start answering questions, spotting patterns, and helping you plan ahead.",
    no_bank_cta: "Connect bank",
    input_placeholder: "Ask me anything about your finances...",
    change_status: "Change Status"
  },
  pt: {
    title: "Assistente de IA",
    subtitle: "O teu assistente financeiro privado",
    state_green_headline: "Fica tranquilo",
    state_yellow_headline: "Atenção",
    state_red_headline: "Ups!",
    state_green_support_1: "Tudo equilibrado e a funcionar bem.",
    state_green_support_2: "Fluxo de caixa estável · Sem riscos imediatos detetados.",
    state_green_support_3: "Todos os indicadores principais estão dentro de valores saudáveis.",
    state_green_support_4: "Sem alterações significativas desde a última verificação.",
    state_green_support_5: "A tua atividade financeira parece estável e previsível.",
    state_green_support_6: "Tudo está a operar dentro dos parâmetros esperados.",
    state_yellow_support: "As despesas estão a aumentar em comparação com o período anterior.",
    state_red_support: "O teu fluxo de caixa está negativo.",
    today_in_finances: "Hoje nas tuas finanças",
    green_insight_1: "Despesas mantiveram-se estáveis esta semana",
    green_insight_2: "2 faturas esperadas nos próximos 7 dias",
    green_insight_3: "Sem padrões de gastos invulgares detetados",
    yellow_insight_1: "Despesas aumentaram vs mês passado",
    yellow_insight_2: "Saídas de caixa estão a acelerar",
    yellow_insight_3: "Uma categoria a impulsionar a maior parte do crescimento",
    red_insight_1: "O que está a causar isto",
    red_insight_2: "Despesas em que podes atuar",
    red_insight_3: "Quando o teu saldo pode recuperar",
    green_message: "Tudo parece estável neste momento. Posso ajudar-te a rever o teu fluxo de caixa, explorar despesas ou planear o futuro.",
    yellow_message: "Reparei que as tuas despesas estão a aumentar. Posso dividi-las por categoria ou mostrar como isto afeta o teu fluxo de caixa.",
    red_message: "O teu fluxo de caixa está atualmente negativo. Posso ajudar-te a perceber o que está a causar isto, identificar despesas para atuar ou ver quando o teu saldo pode recuperar.",
    no_bank_title: "Começa a conversa",
    no_bank_description: "Quando o teu banco estiver conectado, o teu dinheiro pode começar a responder a perguntas, detetar padrões e ajudar-te a planear.",
    no_bank_cta: "Conectar banco",
    input_placeholder: "Pergunta-me qualquer coisa sobre as tuas finanças...",
    change_status: "Mudar Estado"
  },
  da: {
    title: "AI-assistent",
    subtitle: "Din private finansielle AI-assistent",
    state_green_headline: "Tag det roligt",
    state_yellow_headline: "Pas på",
    state_red_headline: "Ups!",
    state_green_support_1: "Alt er afbalanceret og kører problemfrit.",
    state_green_support_2: "Pengestrøm stabil · Ingen umiddelbare risici registreret.",
    state_green_support_3: "Alle nøgleindikatorer er inden for sunde intervaller.",
    state_green_support_4: "Ingen væsentlige ændringer siden dit sidste tjek.",
    state_green_support_5: "Din finansielle aktivitet ser stabil og forudsigelig ud.",
    state_green_support_6: "Alt fungerer inden for forventede parametre.",
    state_yellow_support: "Udgifterne stiger sammenlignet med den foregående periode.",
    state_red_support: "Din pengestrøm er negativ.",
    today_in_finances: "I dag i din økonomi",
    green_insight_1: "Udgifterne forblev stabile denne uge",
    green_insight_2: "2 fakturaer forventes inden for de næste 7 dage",
    green_insight_3: "Ingen usædvanlige forbrugsmønstre registreret",
    yellow_insight_1: "Udgifterne steg vs sidste måned",
    yellow_insight_2: "Pengestrømmen ud accelererer",
    yellow_insight_3: "Én kategori driver det meste af væksten",
    red_insight_1: "Hvad forårsager dette",
    red_insight_2: "Udgifter du kan handle på",
    red_insight_3: "Hvornår din saldo kan genoprettes",
    green_message: "Alt ser stabilt ud lige nu. Jeg kan hjælpe dig med at gennemgå din pengestrøm, udforske udgifter eller planlægge fremad.",
    yellow_message: "Jeg har bemærket, at dine udgifter stiger. Jeg kan opdele dem efter kategori eller vise, hvordan dette påvirker din pengestrøm.",
    red_message: "Din pengestrøm er i øjeblikket negativ. Jeg kan hjælpe dig med at forstå, hvad der forårsager det, identificere udgifter at handle på eller se, hvornår din saldo kan genoprettes.",
    no_bank_title: "Start samtalen",
    no_bank_description: "Når din bank er tilsluttet, kan dine penge begynde at besvare spørgsmål, spotte mønstre og hjælpe dig med at planlægge.",
    no_bank_cta: "Tilslut bank",
    input_placeholder: "Spørg mig om hvad som helst om din økonomi...",
    change_status: "Skift Status"
  },
  es: {
    title: "Asistente de IA",
    subtitle: "Tu asistente financiero privado de IA",
    state_green_headline: "Tranqui",
    state_yellow_headline: "Ojo",
    state_red_headline: "¡Vaya!",
    state_green_support_1: "Todo equilibrado y funcionando sin problemas.",
    state_green_support_2: "Flujo de caja estable · Sin riesgos inmediatos detectados.",
    state_green_support_3: "Todos los indicadores clave están dentro de rangos saludables.",
    state_green_support_4: "Sin cambios significativos desde tu última revisión.",
    state_green_support_5: "Tu actividad financiera parece estable y predecible.",
    state_green_support_6: "Todo está operando dentro de los parámetros esperados.",
    state_yellow_support: "Los gastos están aumentando en comparación con el período anterior.",
    state_red_support: "Tu flujo de caja es negativo.",
    today_in_finances: "Hoy en tus finanzas",
    green_insight_1: "Los gastos se mantuvieron estables esta semana",
    green_insight_2: "2 facturas esperadas en los próximos 7 días",
    green_insight_3: "No se detectaron patrones de gasto inusuales",
    yellow_insight_1: "Los gastos aumentaron vs el mes pasado",
    yellow_insight_2: "Las salidas de efectivo se están acelerando",
    yellow_insight_3: "Una categoría impulsando la mayor parte del crecimiento",
    red_insight_1: "Qué está causando esto",
    red_insight_2: "Gastos en los que puedes actuar",
    red_insight_3: "Cuándo tu saldo podría recuperarse",
    green_message: "Todo parece estable ahora mismo. Puedo ayudarte a revisar tu flujo de caja, explorar gastos o planificar el futuro.",
    yellow_message: "He notado que tus gastos están aumentando. Puedo desglosarlos por categoría o mostrar cómo esto afecta tu flujo de caja.",
    red_message: "Tu flujo de caja está actualmente negativo. Puedo ayudarte a entender qué lo está causando, identificar gastos para actuar o ver cuándo tu saldo podría recuperarse.",
    no_bank_title: "Empieza la conversación",
    no_bank_description: "Una vez que tu banco esté conectado, tu dinero puede empezar a responder preguntas, detectar patrones y ayudarte a planificar.",
    no_bank_cta: "Conectar banco",
    input_placeholder: "Pregúntame lo que quieras sobre tus finanzas...",
    change_status: "Cambiar Estado"
  },
  et: {
    title: "AI-assistent",
    subtitle: "Sinu privaatne finants-IA assistent",
    state_green_headline: "Lõõgastu",
    state_yellow_headline: "Ole ettevaatlik",
    state_red_headline: "Oih!",
    state_green_support_1: "Kõik on tasakaalus ja töötab sujuvalt.",
    state_green_support_2: "Rahavoog stabiilne · Koheseid riske ei tuvastatud.",
    state_green_support_3: "Kõik põhinäitajad on tervislike vahemike piires.",
    state_green_support_4: "Märkimisväärseid muutusi pole pärast viimast kontrolli.",
    state_green_support_5: "Sinu finantsaktiivsus näib stabiilne ja prognoositav.",
    state_green_support_6: "Kõik töötab oodatud parameetrite piires.",
    state_yellow_support: "Kulud kasvavad võrreldes eelmise perioodiga.",
    state_red_support: "Sinu rahavoog on negatiivne.",
    today_in_finances: "Täna sinu finantsis",
    green_insight_1: "Kulud püsisid sel nädalal stabiilsed",
    green_insight_2: "2 arvet oodatakse järgmise 7 päeva jooksul",
    green_insight_3: "Ebatavalisi kulumustreid ei tuvastatud",
    yellow_insight_1: "Kulud kasvasid vs eelmine kuu",
    yellow_insight_2: "Raha väljavool kiirenes",
    yellow_insight_3: "Üks kategooria juhib enamikku kasvust",
    red_insight_1: "Mis seda põhjustab",
    red_insight_2: "Kulud, millega saad tegutseda",
    red_insight_3: "Millal sinu saldo võib taastuda",
    green_message: "Kõik näib praegu stabiilne. Võin aidata sul üle vaadata rahavoogu, uurida kulusid või planeerida tulevikku.",
    yellow_message: "Olen märganud, et sinu kulud kasvavad. Võin need kategooriate kaupa jagada või näidata, kuidas see mõjutab sinu rahavoogu.",
    red_message: "Sinu rahavoog on praegu negatiivne. Võin aidata sul mõista, mis seda põhjustab, tuvastada kulusid, millega tegutseda, või näha, millal sinu saldo võib taastuda.",
    no_bank_title: "Alusta vestlust",
    no_bank_description: "Kui sinu pank on ühendatud, saab sinu raha hakata küsimustele vastama, mustreid tuvastama ja aidata sul tulevikku planeerida.",
    no_bank_cta: "Ühenda pank",
    input_placeholder: "Küsi minult midagi oma finantside kohta...",
    change_status: "Muuda Olekut"
  },
  de: {
    title: "KI-Assistent",
    subtitle: "Dein privater Finanz-KI-Assistent",
    state_green_headline: "Entspann dich",
    state_yellow_headline: "Aufgepasst",
    state_red_headline: "Hoppla!",
    state_green_support_1: "Alles ausgeglichen und läuft reibungslos.",
    state_green_support_2: "Cashflow stabil · Keine unmittelbaren Risiken erkannt.",
    state_green_support_3: "Alle Schlüsselindikatoren liegen in gesunden Bereichen.",
    state_green_support_4: "Keine wesentlichen Änderungen seit deiner letzten Überprüfung.",
    state_green_support_5: "Deine finanzielle Aktivität sieht stabil und vorhersehbar aus.",
    state_green_support_6: "Alles funktioniert innerhalb der erwarteten Parameter.",
    state_yellow_support: "Die Ausgaben steigen im Vergleich zum vorherigen Zeitraum.",
    state_red_support: "Dein Cashflow ist negativ.",
    today_in_finances: "Heute in deinen Finanzen",
    green_insight_1: "Ausgaben blieben diese Woche stabil",
    green_insight_2: "2 Rechnungen in den nächsten 7 Tagen erwartet",
    green_insight_3: "Keine ungewöhnlichen Ausgabenmuster erkannt",
    yellow_insight_1: "Ausgaben stiegen vs letzten Monat",
    yellow_insight_2: "Geldabflüsse beschleunigen sich",
    yellow_insight_3: "Eine Kategorie treibt den Großteil des Wachstums",
    red_insight_1: "Was dies verursacht",
    red_insight_2: "Ausgaben, bei denen du handeln kannst",
    red_insight_3: "Wann sich dein Saldo erholen könnte",
    green_message: "Alles sieht gerade stabil aus. Ich kann dir helfen, deinen Cashflow zu überprüfen, Ausgaben zu erkunden oder vorauszuplanen.",
    yellow_message: "Ich habe bemerkt, dass deine Ausgaben steigen. Ich kann sie nach Kategorien aufschlüsseln oder zeigen, wie sich dies auf deinen Cashflow auswirkt.",
    red_message: "Dein Cashflow ist derzeit negativ. Ich kann dir helfen zu verstehen, was dies verursacht, Ausgaben zu identifizieren, bei denen du handeln kannst, oder zu sehen, wann sich dein Saldo erholen könnte.",
    no_bank_title: "Starte das Gespräch",
    no_bank_description: "Sobald deine Bank verbunden ist, kann dein Geld Fragen beantworten, Muster erkennen und dir beim Planen helfen.",
    no_bank_cta: "Bank verbinden",
    input_placeholder: "Frag mich alles über deine Finanzen...",
    change_status: "Status ändern"
  },
  fr: {
    title: "Assistant IA",
    subtitle: "Votre assistant financier IA privé",
    state_green_headline: "Reste cool",
    state_yellow_headline: "Attention",
    state_red_headline: "Aïe !",
    state_green_support_1: "Tout est équilibré et fonctionne bien.",
    state_green_support_2: "Flux de trésorerie stable · Aucun risque immédiat détecté.",
    state_green_support_3: "Tous les indicateurs clés sont dans des fourchettes saines.",
    state_green_support_4: "Aucun changement significatif depuis votre dernière vérification.",
    state_green_support_5: "Votre activité financière semble stable et prévisible.",
    state_green_support_6: "Tout fonctionne dans les paramètres attendus.",
    state_yellow_support: "Les dépenses augmentent par rapport à la période précédente.",
    state_red_support: "Votre flux de trésorerie est négatif.",
    today_in_finances: "Aujourd'hui dans vos finances",
    green_insight_1: "Les dépenses sont restées stables cette semaine",
    green_insight_2: "2 factures attendues dans les 7 prochains jours",
    green_insight_3: "Aucun schéma de dépenses inhabituel détecté",
    yellow_insight_1: "Les dépenses ont augmenté vs le mois dernier",
    yellow_insight_2: "Les sorties de trésorerie s'accélèrent",
    yellow_insight_3: "Une catégorie génère la majeure partie de la croissance",
    red_insight_1: "Ce qui cause cela",
    red_insight_2: "Dépenses sur lesquelles vous pouvez agir",
    red_insight_3: "Quand votre solde pourrait se rétablir",
    green_message: "Tout semble stable en ce moment. Je peux vous aider à examiner votre flux de trésorerie, explorer les dépenses ou planifier l'avenir.",
    yellow_message: "J'ai remarqué que vos dépenses augmentent. Je peux les décomposer par catégorie ou montrer comment cela affecte votre flux de trésorerie.",
    red_message: "Votre flux de trésorerie est actuellement négatif. Je peux vous aider à comprendre ce qui le cause, identifier les dépenses sur lesquelles agir ou voir quand votre solde pourrait se rétablir.",
    no_bank_title: "Commence la conversation",
    no_bank_description: "Une fois votre banque connectée, votre argent peut commencer à répondre aux questions, repérer des tendances et vous aider à planifier.",
    no_bank_cta: "Connecter la banque",
    input_placeholder: "Posez-moi n'importe quelle question sur vos finances...",
    change_status: "Changer le Statut"
  },
  it: {
    title: "Assistente IA",
    subtitle: "Il tuo assistente finanziario IA privato",
    state_green_headline: "Stai tranquillo",
    state_yellow_headline: "Attenzione",
    state_red_headline: "Ops!",
    state_green_support_1: "Tutto equilibrato e funzionante senza problemi.",
    state_green_support_2: "Flusso di cassa stabile · Nessun rischio immediato rilevato.",
    state_green_support_3: "Tutti gli indicatori chiave sono entro intervalli sani.",
    state_green_support_4: "Nessun cambiamento significativo dall'ultimo controllo.",
    state_green_support_5: "La tua attività finanziaria sembra stabile e prevedibile.",
    state_green_support_6: "Tutto funziona entro i parametri previsti.",
    state_yellow_support: "Le spese stanno aumentando rispetto al periodo precedente.",
    state_red_support: "Il tuo flusso di cassa è negativo.",
    today_in_finances: "Oggi nelle tue finanze",
    green_insight_1: "Le spese sono rimaste stabili questa settimana",
    green_insight_2: "2 fatture previste nei prossimi 7 giorni",
    green_insight_3: "Nessun schema di spesa insolito rilevato",
    yellow_insight_1: "Le spese sono aumentate vs il mese scorso",
    yellow_insight_2: "Le uscite di cassa stanno accelerando",
    yellow_insight_3: "Una categoria sta guidando la maggior parte della crescita",
    red_insight_1: "Cosa sta causando questo",
    red_insight_2: "Spese su cui puoi agire",
    red_insight_3: "Quando il tuo saldo potrebbe recuperare",
    green_message: "Tutto sembra stabile al momento. Posso aiutarti a rivedere il tuo flusso di cassa, esplorare le spese o pianificare il futuro.",
    yellow_message: "Ho notato che le tue spese stanno aumentando. Posso suddividerle per categoria o mostrare come questo influisce sul tuo flusso di cassa.",
    red_message: "Il tuo flusso di cassa è attualmente negativo. Posso aiutarti a capire cosa lo sta causando, identificare le spese su cui agire o vedere quando il tuo saldo potrebbe recuperare.",
    no_bank_title: "Inizia la conversazione",
    no_bank_description: "Una volta collegata la banca, il tuo denaro può iniziare a rispondere alle domande, individuare schemi e aiutarti a pianificare.",
    no_bank_cta: "Collega banca",
    input_placeholder: "Chiedimi qualsiasi cosa sulle tue finanze...",
    change_status: "Cambia Stato"
  },
  nl: {
    title: "AI-assistent",
    subtitle: "Je privé financiële AI-assistent",
    state_green_headline: "Relax maar",
    state_yellow_headline: "Let op",
    state_red_headline: "Oeps!",
    state_green_support_1: "Alles in balans en loopt soepel.",
    state_green_support_2: "Cashflow stabiel · Geen directe risico's gedetecteerd.",
    state_green_support_3: "Alle belangrijke indicatoren liggen binnen gezonde bereiken.",
    state_green_support_4: "Geen significante veranderingen sinds je laatste controle.",
    state_green_support_5: "Je financiële activiteit ziet er stabiel en voorspelbaar uit.",
    state_green_support_6: "Alles functioneert binnen de verwachte parameters.",
    state_yellow_support: "Uitgaven stijgen vergeleken met de vorige periode.",
    state_red_support: "Je cashflow is negatief.",
    today_in_finances: "Vandaag in je financiën",
    green_insight_1: "Uitgaven bleven stabiel deze week",
    green_insight_2: "2 facturen verwacht in de komende 7 dagen",
    green_insight_3: "Geen ongebruikelijke uitgavenpatronen gedetecteerd",
    yellow_insight_1: "Uitgaven stegen vs vorige maand",
    yellow_insight_2: "Gelduitstroom versnelt",
    yellow_insight_3: "Eén categorie drijft het grootste deel van de groei",
    red_insight_1: "Wat dit veroorzaakt",
    red_insight_2: "Uitgaven waarop je kunt handelen",
    red_insight_3: "Wanneer je saldo zou kunnen herstellen",
    green_message: "Alles ziet er momenteel stabiel uit. Ik kan je helpen je cashflow te bekijken, uitgaven te verkennen of vooruit te plannen.",
    yellow_message: "Ik heb gemerkt dat je uitgaven stijgen. Ik kan ze opdelen per categorie of laten zien hoe dit je cashflow beïnvloedt.",
    red_message: "Je cashflow is momenteel negatief. Ik kan je helpen begrijpen wat dit veroorzaakt, uitgaven identificeren om op te handelen of zien wanneer je saldo zou kunnen herstellen.",
    no_bank_title: "Start het gesprek",
    no_bank_description: "Zodra je bank is gekoppeld, kan je geld vragen beantwoorden, patronen herkennen en je helpen plannen.",
    no_bank_cta: "Bank koppelen",
    input_placeholder: "Vraag me wat dan ook over je financiën...",
    change_status: "Status wijzigen"
  },
  sv: {
    title: "AI-assistent",
    subtitle: "Din privata finansiella AI-assistent",
    state_green_headline: "Ta det lugnt",
    state_yellow_headline: "Se upp",
    state_red_headline: "Hoppsan!",
    state_green_support_1: "Allt balanserat och fungerar smidigt.",
    state_green_support_2: "Kassaflöde stabilt · Inga omedelbara risker upptäckta.",
    state_green_support_3: "Alla nyckelindikatorer ligger inom friska intervall.",
    state_green_support_4: "Inga betydande förändringar sedan din senaste koll.",
    state_green_support_5: "Din finansiella aktivitet ser stabil och förutsägbar ut.",
    state_green_support_6: "Allt fungerar inom förväntade parametrar.",
    state_yellow_support: "Utgifterna ökar jämfört med föregående period.",
    state_red_support: "Ditt kassaflöde är negativt.",
    today_in_finances: "Idag i din ekonomi",
    green_insight_1: "Utgifterna förblev stabila denna vecka",
    green_insight_2: "2 fakturor förväntas inom de närmaste 7 dagarna",
    green_insight_3: "Inga ovanliga utgiftsmönster upptäckta",
    yellow_insight_1: "Utgifterna ökade vs förra månaden",
    yellow_insight_2: "Kassautflöden accelererar",
    yellow_insight_3: "En kategori driver merparten av tillväxten",
    red_insight_1: "Vad som orsakar detta",
    red_insight_2: "Utgifter du kan agera på",
    red_insight_3: "När ditt saldo kan återhämta sig",
    green_message: "Allt ser stabilt ut just nu. Jag kan hjälpa dig att granska ditt kassaflöde, utforska utgifter eller planera framåt.",
    yellow_message: "Jag har märkt att dina utgifter ökar. Jag kan dela upp dem efter kategori eller visa hur detta påverkar ditt kassaflöde.",
    red_message: "Ditt kassaflöde är för närvarande negativt. Jag kan hjälpa dig förstå vad som orsakar det, identifiera utgifter att agera på eller se när ditt saldo kan återhämta sig.",
    no_bank_title: "Starta samtalet",
    no_bank_description: "När din bank är ansluten kan dina pengar börja svara på frågor, upptäcka mönster och hjälpa dig planera.",
    no_bank_cta: "Anslut bank",
    input_placeholder: "Fråga mig vad som helst om din ekonomi...",
    change_status: "Ändra Status"
  },
  fi: {
    title: "AI-avustaja",
    subtitle: "Yksityinen talous-AI-avustajasi",
    state_green_headline: "Rentoudu",
    state_yellow_headline: "Varo",
    state_red_headline: "Hups!",
    state_green_support_1: "Kaikki tasapainossa ja toimii moitteettomasti.",
    state_green_support_2: "Kassavirta vakaa · Ei välittömiä riskejä havaittu.",
    state_green_support_3: "Kaikki avainmittarit ovat terveillä alueilla.",
    state_green_support_4: "Ei merkittäviä muutoksia viime tarkastuksen jälkeen.",
    state_green_support_5: "Taloudellinen toimintasi näyttää vakaalta ja ennustettavalta.",
    state_green_support_6: "Kaikki toimii odotettujen parametrien sisällä.",
    state_yellow_support: "Kulut kasvavat verrattuna edelliseen jaksoon.",
    state_red_support: "Kassavirtasi on negatiivinen.",
    today_in_finances: "Tänään taloudessasi",
    green_insight_1: "Kulut pysyivät vakaina tällä viikolla",
    green_insight_2: "2 laskua odotetaan seuraavan 7 päivän aikana",
    green_insight_3: "Ei epätavallisia kulutustapoja havaittu",
    yellow_insight_1: "Kulut kasvoivat vs viime kuukausi",
    yellow_insight_2: "Rahan ulosvirtaus kiihtyy",
    yellow_insight_3: "Yksi kategoria ajaa suurimman osan kasvusta",
    red_insight_1: "Mikä tämän aiheuttaa",
    red_insight_2: "Kulut, joihin voit toimia",
    red_insight_3: "Milloin saldosi voi palautua",
    green_message: "Kaikki näyttää vakaalta juuri nyt. Voin auttaa sinua tarkastelemaan kassavirtaasi, tutkimaan kuluja tai suunnittelemaan eteenpäin.",
    yellow_message: "Olen huomannut, että kulusi kasvavat. Voin jakaa ne kategorioittain tai näyttää, miten tämä vaikuttaa kassavirtaasi.",
    red_message: "Kassavirtasi on tällä hetkellä negatiivinen. Voin auttaa sinua ymmärtämään, mikä sen aiheuttaa, tunnistamaan kulut, joihin toimia, tai näkemään, milloin saldosi voi palautua.",
    no_bank_title: "Aloita keskustelu",
    no_bank_description: "Kun pankkisi on yhdistetty, rahasi voivat alkaa vastata kysymyksiin, havaita kuvioita ja auttaa sinua suunnittelemaan.",
    no_bank_cta: "Yhdistä pankki",
    input_placeholder: "Kysy minulta mitä tahansa taloudestasi...",
    change_status: "Vaihda Tila"
  }
};
